"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const DoubleAmountField = ({ attributes, callbacks, editable, SHOW_ALL, txn, currencySymbol, // state
amountEditable, currEditFieldName, field, enableAutoFocus, focusField, }) => {
    var _a, _b;
    const { classes, theme } = useStyles();
    const thisFieldActive = (amountEditable && editable && (currEditFieldName === field));
    let value = '0';
    if (thisFieldActive) {
        // we need to just pass through the current txn amount string
        const amountValid = (field === 'expense') ? txn.amount <= 0 : txn.amount > 0;
        value = amountValid ? txn.amount : '&';
    }
    else {
        const amountValid = (field === 'expense') ? txn.amount <= 0 : txn.amount > 0;
        value = amountValid ? Math.abs(txn.amount) : '&';
    }
    const zeroIsBlank = txn.amount === 0 ? (field !== 'expense') : true;
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)('amount', classes.regItem, 'protectWidth', thisFieldActive ? 'editable' : '')}>
      {SHOW_ALL &&
            <AmountField_1.default 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            disableUnderline={(_a = theme.components) === null || _a === void 0 ? void 0 : _a.register.noUnderline} clickable={amountEditable ? 'true' : null} amountType={field} 
            // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
            onChange={callbacks.handleChange} onBlur={(e) => {
                    var _a;
                    (_a = callbacks.onAmountBlur) === null || _a === void 0 ? void 0 : _a.call(callbacks, e, field);
                }} editable={thisFieldActive} autoFocus={enableAutoFocus} 
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            fontSize={(_b = theme.components) === null || _b === void 0 ? void 0 : _b.register.fontSize.default} 
            // @ts-expect-error: Type 'string' is not assignable to type 'number'.
            value={String(value)} color={field === 'expense' ? 'black' : 'green'} useAbsoluteValue={field === 'expense'} zeroIsBlank={zeroIsBlank} className={(0, classnames_1.default)(classes.regInput, 'amount')} currencySymbol={currencySymbol} 
            // @ts-expect-error: null is not assignable to type
            inputRef={thisFieldActive ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null}>
      </AmountField_1.default>}
    </styles_1.RegListItem>);
};
exports.default = DoubleAmountField;
